import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';

import Page from '../models/Page';

import Layout from '../components/Layout';
import SEO from '../components/SEO';

import styles from '../components/Article.module.scss';

export default function render({data}) {
  const page = Page.fromWP(data.wordpressPage);

  return (
    <Layout solidHeader={true}>
      <SEO title={page.title} description={page.excerpt} ogimage={page.ogimage} />
      <main className="container">
        <div className={styles.wrap}>
          <h1 className="title">{page.title}</h1>
          <div className={styles.text} dangerouslySetInnerHTML={{__html: page.html}} />
        </div>
      </main>
    </Layout>
  );
}

render.propTypes = {
  data: PropTypes.object,
};

export const query = graphql`
  query($id: String!) {
    wordpressPage(id: {eq: $id}) {
      ...WPPage
    }
  }
`;
